export const fmtDate = (iso) => {
    try {
        const d = new Date(iso);
        return d.toLocaleString("es-MX", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
};